<template>
    <div class="container-fluid">
        <div class="row mt-3">
        <div class="col-6 col-sm-6 col-md-6">
        <form @submit.prevent="submit" >
            <div class="form-group" v-if="errors.length" >
                <ul class="list-group">
                    <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
            </div>
            <div class="form-group input-group-sm">
                <label >Punkt zakupu</label>
                <select class="form-control" v-model="form.storeOfPurchaseId">
                    <option v-for="option in storesOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
                <label >Punkt w którym znajduje się telefon</label>
                <select class="form-control" v-model="form.actualStoreId">
                    <option v-for="option in storesOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
                <label >Model telefonu:</label>
                <async-search-input
                    v-model="form.phoneNameId"
                    v-bind:dataProvider="phoneNamesDataProvider"
                    v-bind:dataMapper="searchPhoneNamesMapper"
                />
            </div>
            <div class="form-group input-group-sm">
                <label >Kolor telefonu:</label>
                <async-search-input
                    v-model="form.colorId"
                    v-bind:dataProvider="colorsDataProvider"
                    v-bind:dataMapper="searchColorsMapper"
                />
            </div>
            <div class="form-group input-group-sm">
                <label >Kwota zakupu</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.paidAmount"/>
            </div>
            <div class="form-group input-group-sm">
                <label >Sugerowana kwota sprzedaży</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.suggestedPrice"/>
            </div>
            <div class="form-group input-group-sm">
                <label >Gwarancja</label>
                <div class="custom-control custom-radio">
                    <input type="radio" name="customRadio" class="custom-control-input" id="NoGuarantee"
                        value="NoGuarantee" v-model="guaranteeValue">
                    <label class="custom-control-label" for="NoGuarantee">Brak gwarancji</label>
                </div>
                <div class="custom-control custom-radio">
                    <input type="radio" name="customRadio" class="custom-control-input" id="DateGuarantee" 
                       value="DateGuarantee" v-model="guaranteeValue">
                    <label class="custom-control-label" for="DateGuarantee">Gwarnacja do:</label>
                    <div v-if="dateGuaranteeSelected">
                        <datepicker 
                            class="mt-1 "
                            v-model="guaranteeDateValue"
                            :monday-first="true"
                            :language="lang"
                        ></datepicker>
                    </div>
                </div>
            </div>
            <div class="form-group input-group-sm">
                <label >Simlock</label>
                <select class="form-control" v-model="form.simLock">
                    <option v-for="option in simLockOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
                <label >Pochodzenie telefonu</label>
                <select class="form-control" v-model="form.phoneOrigin">
                    <option v-for="option in phoneOriginOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
                <label >Stan telefonu</label>
                <select class="form-control" v-model="form.phoneState">
                    <option v-for="option in phoneStateOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
            <label >Data zakupu</label>
            <datepicker 
                    class="mt-1 "
                    v-model="form.dateOfPurchase"
                    :monday-first="true"
                    :language="lang"
                ></datepicker>
            </div>
            <input class="btn btn-success torre-btn btn-sm mr-2" type="submit" value="Zapisz">
            <router-link class="btn btn-secondary btn-sm" :to="{ name: 'phones' }">Anuluj</router-link>
        </form>
        </div>
        </div>
    </div>
</template>
<script>
import {pl} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import alertify from 'alertifyjs'
import PhonesService from "@/components/phones/PhonesService"

const phonesService = new PhonesService()

export default {
    components: {
      datepicker 
    },
    name: "PhonesNew",
    data: function () {
        return {
            phoneNamesDataProvider: phonesService.searchPhoneNames,
            searchPhoneNamesMapper: phonesService.searchPhoneNamesMapper,
            colorsDataProvider: phonesService.searchColors,
            searchColorsMapper: phonesService.searchColorsMapper,
            errors: [],
            simLockOptions: [],
            phoneStateOptions: [],
            phoneOriginOptions: [],
            storesOptions: [],
            lang: pl,
            guaranteeValue: "",
            guaranteeDateValue: moment().format("YYYY-MM-DD HH:mm:ss"),
            form: {
                phoneNameId: "",
                colorId: "",
                storeOfPurchaseId: -1,
                actualStoreId: -1,
                phoneOrigin: "-1",
                simLock: "-1",
                phoneState: "-1",
                dateOfPurchase: moment().format("YYYY-MM-DD HH:mm:ss"),
                paidAmount: "",
                suggestedPrice: "",
            }
        }
    },
    computed: {
        dateGuaranteeSelected() {
            return this.guaranteeValue === "DateGuarantee"
        }
    },
    created() {
        this.loadConfig()
        this.initStoresOptions()
    },
    methods: {
        submit() {
            this.clearErrors()
            const newForm = {
                ...this.form, 
                ...{
                    guarantee: phonesService.parseGuarantee(this.guaranteeValue, this.guaranteeDateValue)
                    }
                }
            phonesService.addPhone(newForm, this.onAddSuccess, this.onAddError)
        },
        onAddSuccess(data) {
            this.$router.push({name: 'phones'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Telefon został zapisany").delay(3);
        },
        onAddError(err) {
            console.log(err)
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można dodać telefonu.").delay(3);
        },
        clearErrors() {
            this.errors = []
        },
        loadConfig() {
            phonesService.loadConfig(this.initView)
        },
        initView(config) {
            this.simLockOptions = phonesService.initOptions(config.SimLock, "-1", "Simlock")
            this.phoneStateOptions = phonesService.initOptions(config.PhoneState, "-1", "PhoneState")
            this.phoneOriginOptions = phonesService.initOptions(config.PhoneOrigin, "-1", "PhoneOrigin")
        },
        initStoresOptions() {
            phonesService.initStores(this.onStoresSuccess)
        },
        onStoresSuccess(data, selectedStoreId) {
            this.storesOptions = data
            this.form.storeOfPurchaseId = selectedStoreId
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/phones/PhonesNew.vue